import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const DeleteFamilyMutation = graphql.persisted(
  "DeleteFamilyMutation",
  graphql(`
    mutation DeleteFamilyMutation($input: DeleteFamilyInput!) {
      deleteFamily(input: $input) {
        success
        userErrors {
          message
          path
        }
      }
    }
  `)
);

export { DeleteFamilyMutation };

export function useDeleteFamily() {
  return useMutation(DeleteFamilyMutation);
}
